// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import type { SchemaMigration } from './types'
import { MigrationRegistry } from './registry'
import { contentpiecesMigrations } from './contentpieces/index'
import { missionsMigrations } from './missions/index'

/**
 * All known schema migrations aggregated from per-schema directories.
 *
 * When adding a new schema's migrations, import them here and add to the array.
 */
const allMigrationArrays: SchemaMigration[][] = [
  contentpiecesMigrations,
  missionsMigrations,
  // Add new schema migrations here as they are created:
  // dealsMigrations,
  // audiencesMigrations,
]

/** Flat list of all migrations across all schemas. */
export const allMigrations: SchemaMigration[] = allMigrationArrays.flat()

/**
 * Create a MigrationRegistry pre-loaded with all known migrations.
 * This is the primary entry point for the CLI and other consumers.
 */
export function createMigrationRegistry(): MigrationRegistry {
  const registry = new MigrationRegistry()
  for (const migration of allMigrations) {
    registry.register(migration)
  }
  return registry
}
